import { format } from "date-fns/format";
import { parseISO } from "date-fns/parseISO";

export class Util {

    static formatDate(inputDate: Date): string {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const day   = inputDate.getDate();
        const month = monthNames[inputDate.getMonth()];
        const year  = inputDate.getFullYear();

        return `${month} ${day}, ${year}`;
    }

    static formatRelativeTime(inputDate : Date) : string
    {
        const now           = new Date();
        const diffInMs      = now.getTime() - inputDate.getTime();
        const diffInSeconds = Math.floor(diffInMs / 1000);

        // Handle future dates
        if (diffInSeconds < 0) {
            return "in the future";
        }

        // Less than a minute
        if (diffInSeconds < 60) {
            return "just now";
        }

        // Minutes
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) {
            return diffInMinutes === 1 ? "1 minute ago" : `${diffInMinutes} minutes ago`;
        }

        // Hours
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) {
            return diffInHours === 1 ? "1 hour ago" : `${diffInHours} hours ago`;
        }

        // Days
        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 7) {
            return diffInDays === 1 ? "1 day ago" : `${diffInDays} days ago`;
        }

        const diffInMonths = (now.getFullYear() - inputDate.getFullYear()) * 12 + (now.getMonth() - inputDate.getMonth());
        if (diffInMonths <= 0) {
            // Weeks
            const diffInWeeks = Math.floor(diffInDays / 7);
            return diffInWeeks === 1 ? "1 week ago" : `${diffInWeeks} weeks ago`;
        }

        // Months (approximate)
        if (diffInMonths < 12) {
            return diffInMonths === 1 ? "1 month ago" : `${diffInMonths} months ago`;
        }

        // Years (approximate)
        const diffInYears = Math.floor(diffInDays / 365);
        return diffInYears === 1 ? "1 year ago" : `${diffInYears} years ago`;
    }

    static getTigerAPIUrl() : string
    {
        return window.location.protocol + "//" + window.location.host + "/";
    }

    static getTigerCityUrl() : string
    {
        if (this.isPrerendering()) {
            return "https://tigercity.ai/";
        }
        return window.location.protocol + "//" + window.location.host + "/";
    }

    static isPrerendering()
    {
        return (typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap');
    }

    static getDateTimeFormatted(date: Date): string {
        // ISO-like timestamp in local time (no milliseconds, no timezone suffix)
        const pad = (n: number) => String(n).padStart(2, "0");
        const yyyy = date.getFullYear();
        const MM   = pad(date.getMonth() + 1);
        const dd   = pad(date.getDate());
        const HH   = pad(date.getHours());
        const mm   = pad(date.getMinutes());
        const ss   = pad(date.getSeconds());
        return `${yyyy}-${MM}-${dd}T${HH}:${mm}:${ss}`;
    }

    static formatDateReadable(date: string): string {
        const day = parseISO(date);
        return format(day, "do 'of' MMMM, yyyy 'at' h:mm a");
    }

};

